// Sprint 11.6 Block 2 — Task 3: 5 Erkennungsmerkmale + 2x2-Matrix-Daten
// Content vom User geliefert (30.06.2026). Alltagstauglich, kein Wissenschafts-Sprech.
// Genus-korrekte Artikel siehe FOKUSTYP_ARTIKEL.

export const FT_ARTIKEL_NOMINATIV = {
  eule: "die",
  biene: "die",
  katze: "die",
  hund: "der",
};

export const FT_PRONOMEN = {
  eule: "sie",
  biene: "sie",
  katze: "sie",
  hund: "er",
};

// 5 Erkennungsmerkmal-Kategorien pro FT
export const FT_ERKENNUNGSMERKMALE = {
  biene: {
    verhalten:
      "Plant, strukturiert, organisiert. Sieht Verbesserungspotenzial in allem.",
    mimik:
      "Konzentriert, leicht angespannt um die Augen. Nickt anerkennend.",
    reaktion:
      "Korrigiert sofort, direkt, ohne Drama. Will es richtig machen.",
    umgebung:
      "Ordentliche, durchdachte Räume. Unordnung stresst sie sichtbar.",
    erste_verarbeitung:
      "Denkt in Lösungen. \u201eWas muss getan werden?\u201c",
  },
  eule: {
    verhalten:
      "Beobachtet, analysiert, ordnet ein. Spricht erst nach dem Denken.",
    mimik:
      "Ruhig, nachdenklich, leicht zur Seite geneigter Kopf. Halbes Lächeln bei interessanten Gedanken.",
    reaktion:
      "Fragt präzise nach, wenn unklar. Will verstehen, nicht bewerten.",
    umgebung: "Braucht Ruhe. Lärm und Chaos lenken sie ab.",
    erste_verarbeitung: "Denkt erst, fühlt später. \u201eWas bedeutet das?\u201c",
  },
  katze: {
    verhalten:
      "Reagiert impulsiv, spontan, aus dem Bauch. Folgt Lust und Reizen.",
    mimik:
      "Lebendig, wach, schnell wechselnde Ausdrücke. Große Augen bei Interesse, enger Blick bei Widerwillen.",
    reaktion:
      "Sagt sofort nein, wenn sie nicht will. Direkt, manchmal provokant.",
    umgebung:
      "Braucht Freiheit und Wahlmöglichkeiten. Regeln engen sie ein.",
    erste_verarbeitung:
      "Fühlt zuerst, denkt später. \u201eWas reizt mich? Was nervt mich?\u201c",
  },
  hund: {
    verhalten:
      "Passt sich an, liest Stimmungen, sucht Zugehörigkeit. Oft unsicher.",
    mimik:
      "Aufmerksam, sucht Blickkontakt, leicht besorgt. Lächelt schnell, um zu gefallen.",
    reaktion:
      "Weicht Konflikten aus, lenkt ein, gibt nach. Grübelt später nach.",
    umgebung:
      "Braucht Sicherheit und Bestätigung. Kritik trifft tief.",
    erste_verarbeitung:
      "Fühlt sofort, denkt über sich. \u201eWas denkt die andere Person über mich?\u201c",
  },
};

// Reihenfolge der 5 Kategorien (mit Labels)
export const ERKENNUNGSMERKMAL_ORDER = [
  { key: "verhalten", label: "Verhalten" },
  { key: "mimik", label: "Mimik" },
  { key: "reaktion", label: "Reaktion" },
  { key: "umgebung", label: "Umgebung" },
  { key: "erste_verarbeitung", label: "Erste Verarbeitung" },
];

// 2x2-Matrix-Positionen
// Achsen: Y = Wollen (oben) / Tun-Können (unten)
//         X = Emotional (links) / Rational (rechts)
// NICHT „Kopf/Bauch" (siehe User-Spec, 30.06.2026)
export const MATRIX_AXES = {
  y: { top: "Wollen", bottom: "Tun-Können" },
  x: { left: "Emotional", right: "Rational" },
};

// Position pro FT als 0..1-Koordinate (0 links/oben, 1 rechts/unten)
// Katze: oben-links | Eule: oben-rechts | Hund: unten-links | Biene: unten-rechts
export const MATRIX_POSITION = {
  katze: { x: 0.22, y: 0.22 },
  eule: { x: 0.78, y: 0.22 },
  hund: { x: 0.22, y: 0.78 },
  biene: { x: 0.78, y: 0.78 },
};

export const MATRIX_DESCRIPTION = {
  katze: "Wollen + Emotional — folgt der Lust, sagt direkt nein.",
  eule: "Wollen + Rational — denkt erst nach, dann handelt sie.",
  hund: "Tun-Können + Emotional — passt sich an, vermeidet Konflikt.",
  biene: "Tun-Können + Rational — organisiert, korrigiert, optimiert.",
};
